// Referral attribution: capture ?ref= on first landing, persist for 30 days.
const REF_KEY = "waos_ref";
const WINDOW_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

// Call on public landing. Stores the ref code if present and not already attributed.
export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref) return;
    // First-touch attribution: only set if none stored yet.
    if (!getStoredRef()) {
      const payload = JSON.stringify({ ref, ts: Date.now() });
      localStorage.setItem(REF_KEY, payload);
      setCookie(REF_KEY, payload, 30);
    }
  } catch {}
}

// Returns the stored ref code if still within the 30-day window, else null.
export function getStoredRef() {
  try {
    const raw = localStorage.getItem(REF_KEY) || getCookie(REF_KEY);
    if (!raw) return null;
    const { ref, ts } = JSON.parse(raw);
    if (!ref || !ts || Date.now() - ts > WINDOW_MS) return null;
    return ref;
  } catch {
    return null;
  }
}
